var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSliderActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.69995 17.4932H1.80932C0.810663 17.4932 0 18.3892 0 19.493C0 20.5953 0.810663 21.4928 1.80932 21.4928H9.69995C10.6986 21.4928 11.5093 20.5953 11.5093 19.493C11.5093 18.3892 10.6986 17.4932 9.69995 17.4932Z",
    fill: "#3864FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M23.9999 4.56105C23.9999 3.45873 23.1892 2.56273 22.1919 2.56273H14.3013C13.3026 2.56273 12.4919 3.45873 12.4919 4.56105C12.4919 5.66484 13.3026 6.56084 14.3013 6.56084H22.1919C23.1892 6.56084 23.9999 5.66484 23.9999 4.56105Z",
    fill: "#3864FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25329 4.56106C8.25329 7.08106 6.40664 9.12359 4.12665 9.12359C1.84799 9.12359 0 7.08106 0 4.56106C0 2.04253 1.84799 0 4.12665 0C6.40664 0 8.25329 2.04253 8.25329 4.56106Z",
    fill: "#3864FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 19.4389C23.9999 21.9575 22.1532 24 19.8732 24C17.5946 24 15.7466 21.9575 15.7466 19.4389C15.7466 16.9189 17.5946 14.8764 19.8732 14.8764C22.1532 14.8764 23.9999 16.9189 23.9999 19.4389Z",
    fill: "#3864FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderActive);
export default __webpack_public_path__ + "static/media/slider-active.33fb98ab22e553fb359bfe37840dc44b.svg";
export { ForwardRef as ReactComponent };